// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function Radio(props) {
  var __border = props.border;
  var __opacity = props.opacity;
  var __marginTop = props.marginTop;
  var __className = props.className;
  var __padding = props.padding;
  var __height = props.height;
  var checked = props.checked;
  var height = __height !== undefined ? __height : "15px";
  var padding = __padding !== undefined ? __padding : "36%";
  var className = __className !== undefined ? __className : "default";
  var marginTop = __marginTop !== undefined ? __marginTop : "0";
  var opacity = __opacity !== undefined ? __opacity : "100%";
  var border = __border !== undefined ? __border : "2px solid currentColor";
  var $$class = checked ? "active" : "inactive";
  var nonActiveOpacity = checked ? "100%" : opacity;
  var css = "\n  input[type=\"radio\"] {\n    -webkit-appearance: none;\n    appearance: none;\n    -moz-appearance: initial;\n  }\n\n  ." + className + $$class + " input[type=\"radio\"] {\n    visibility: hidden;\n}\n\n." + className + $$class + " input[type=\"radio\"]::before {\n    border: " + border + ";\n    height: " + height + ";\n    width: " + height + ";\n    border-radius: 50%;\n    display: block;\n    content: \" \";\n    opacity: " + nonActiveOpacity + ";\n    cursor: pointer;\n    visibility: visible;\n    margin-top: " + marginTop + ";\n}\n\n." + className + $$class + " input[type=\"radio\"]:checked::before {\n    background: radial-gradient(currentColor " + padding + ", transparent 32%);\n}";
  return React.createElement(React.Fragment, {}, React.createElement("style", undefined, css), React.createElement("div", {
                  className: className + $$class + " flex self-center"
                }, React.createElement("input", {
                      className: "Radio",
                      checked: checked,
                      readOnly: true,
                      type: "radio"
                    })));
}

var make = Radio;

export {
  make ,
}
/* react Not a pure module */
